import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ManagementApiService } from '../../../../../services';
import { SettingValueModel } from '../../../models/informate';

@Component({
    selector: 'app-settings-language',
    templateUrl: './settings-language.component.html',
    styleUrls: ['./settings-language.component.scss'],
})
export class SettingsLanguageComponent implements OnInit {
    @Output() languageOutput: EventEmitter<SettingValueModel> = new EventEmitter();

    languageForm: UntypedFormGroup;
    languageList: SettingValueModel[];
    defaultLang: string;

    constructor(
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private user_Utility: UserUtilityService
    ) {}

    ngOnInit(): void {
        this.languageForm = this.fb.group({
            language: [this.defaultLang],
        });
        this.languageForm.get('language').valueChanges.subscribe((value) => this.emitLanguage(value));

        this.getLanguages();
    }

    emitLanguage(settingValueId: any): void {
        this.languageOutput.emit(this.languageList.find((x) => x.settingValueId == settingValueId));
    }

    async getLanguages() {
        let settings = await this.mgmtApi.getSettings().toPromise();
        if (settings !== null) {
            if (settings.success === true) {
                let languageSetting = settings.response.find((x) => x.key == 'DefaultLanguage');
                if (languageSetting != null) {
                    this.languageList = languageSetting.settingValues.filter((x) => x.value !== 'Auto');
                    let userPreferedLang = this.mgmtApi.userDefaults?.find((x) => x.userPreferenceKey == 'DefaultLanguage')?.userPreference;
                    if (userPreferedLang !== null) {
                        this.defaultLang = this.languageList.find((x) => x.value == userPreferedLang).settingValueId;
                    } else {
                        this.defaultLang = this.languageList.find((x) => x.value == languageSetting.default).settingValueId;
                    }
                    this.languageForm.get('language').setValue(this.defaultLang, { emitEvent: true });
                }
            } else {
                this.user_Utility.errorModelPopup(settings.message);
            }
        }
    }
}
